import React, { createContext, useContext, useReducer, useMemo } from 'react';
import { chatReducer, initialChatState } from '../reducers/chat.reducer';

const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [state, dispatch] = useReducer(chatReducer, initialChatState);

  const value = useMemo(() => ({
    state,
    dispatch
  }), [state]);

  return (
    <ChatContext.Provider value={value}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChatContext = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChatContext must be used within a ChatProvider');
  }
  return context;
};
